import * as React from "react";
import { Link } from "react-router-dom"
import Spinner from "../../core/Spinner/Spinner";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import "./Login.css";
import MailIcon from "./mail.svg";
import MessageIcon from "./message.svg";
import PhoneIcon from "./phone-volume-up.svg";

interface ILoginProps extends ITranslationProps {
    onSubmit: (email: string, password: string) => void;
    loginFailed?: boolean;
    formLoginProcessing?: boolean;
    tokenLoginProcessing?: boolean;
}

interface ILoginState {
    email: string;
    password: string;
    emailValid: boolean;
    passwordValid: boolean;
    validated: boolean;
}

class Login extends React.Component<ILoginProps, ILoginState> {

    private formElement: HTMLFormElement | null;

    constructor(props: ILoginProps) {
        super(props);
        this.state = { email: "", password: "", emailValid: true, passwordValid: true, validated: false };

        this.onEmailChange = this.onEmailChange.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onLoginClick = this.onLoginClick.bind(this);
        this.inputKeypress = this.inputKeypress.bind(this);
    }

    public render() {

        if (this.props.tokenLoginProcessing) {
            return <Spinner />;
        }

        return (

            <div>
                {this.props.formLoginProcessing && <Spinner />}

                <div className="row">

                    <div className="col offset-lg-1 home-content">

                        <div className="home-text-top">
                            <div className="home-image"><img src={PhoneIcon} /></div>
                            <div className="home-text-title">{this.props.t("Login.VoiceNotification")}</div>
                            <div className="">{this.props.t("Login.VoiceNotificationCopy")}</div>
                        </div>

                        <div className="home-text-top">
                            <div className="home-image"><img src={MessageIcon} /></div>
                            <div className="home-text-title">{this.props.t("Login.TextMessages")}</div>
                            <div className="">{this.props.t("Login.TextMessagesCopy")}</div>
                        </div>

                        <div className="home-text-top">
                            <div className="home-image"><img src={MailIcon} /></div>
                            <div className="home-text-title">{this.props.t("Login.EmailNotifications")}</div>
                            <div className="">{this.props.t("Login.EmailNotificationsCopy")}</div>
                        </div>

                    </div>

                    <div className="col col-xs-12">

                        <div className="card">
                            <div className="card-header">
                                <h4 >{this.props.t("Login.LoginTitle")}</h4>
                            </div>
                            <div className="card-body">
                                <form ref={ref => this.formElement = ref} className={this.state.validated ? "was-validated" : "needs-validation"} noValidate={true}>
                                    <div className="form-group">
                                        <label>{this.props.t("Login.EmailAddress")}</label>
                                        <input type="email" className="form-control" placeholder={this.props.t("Login.EmailAddress")}
                                            value={this.state.email} onChange={this.onEmailChange} onKeyPress={this.inputKeypress}
                                            required={true} autoFocus={true} />

                                        <div className="invalid-feedback">
                                            {this.props.t("Login.EmailValidationMessage")}
                                        </div>

                                    </div>
                                    <div className="form-group">
                                        <label>{this.props.t("Login.Password")}</label>
                                        <input type="password" className="form-control" placeholder={this.props.t("Login.Password")}
                                            value={this.state.password} onChange={this.onPasswordChange} onKeyPress={this.inputKeypress}
                                            required={true} />

                                        <div className="invalid-feedback">
                                            {this.props.t("Login.PasswordValidationMessage")}
                                        </div>

                                    </div>

                                    <button type="button" className="btn btn-primary" onClick={this.onLoginClick}>{this.props.t("Login.Login")}</button>
                                </form>

                                {this.props.loginFailed && <div className="mt-3 alert alert-danger">{this.props.t("Login.LoginFailed")}</div>}

                                <div className="mt-3">
                                    <Link to="/forgotPassword">{this.props.t("Login.ForgotPasswordLink")}</Link>
                                    <Link to="/registerRequest" className="float-right">{this.props.t("Login.FirstTimeUserLink")}</Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    private onEmailChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ email: event.target.value });
    }

    private onPasswordChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ password: event.target.value });
    }

    private inputKeypress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === "Enter") {
            this.onLoginClick();
        }
    }

    private onLoginClick(): void {
        this.setState({ validated: true });

        if (this.formElement && this.formElement.checkValidity()) {
            this.props.onSubmit(this.state.email, this.state.password);
        }
    }
}

export default translateComponent(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.tsx